import React from 'react'

const Contact = (props) => {
    return <div><h2>Conatct Us Page</h2></div>
}

export default Contact;